// Утилітна функція для визначення backend URL залежно від середовища
// 
// Приклади налаштувань:
// Local: REACT_APP_API_URL=http://localhost:8080
// Prod (same domain): автоматично https://yourdomain.com (без порту)
// Prod (separate API): REACT_APP_API_URL=https://api.yourdomain.com
export function getBackendURL() {
  // 1. Якщо явно задано в environment variables - використовуємо його (РЕКОМЕНДОВАНО)
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }

  // 2. Якщо є старий REACT_APP_BACKEND_URL - використовуємо його (LEGACY)
  if (process.env.REACT_APP_BACKEND_URL) {
    return process.env.REACT_APP_BACKEND_URL;
  }

  // 3. Автоматичне визначення на основі поточного домену
  const currentHost = window.location.hostname;
  const currentPort = window.location.port;
  const currentProtocol = window.location.protocol;
  
  if (currentHost === 'localhost' || currentHost === '127.0.0.1') {
    const backendURL = 'http://localhost:8080';
    return backendURL;
  }
  
  const backendURL = `${currentProtocol}//${currentHost}`;
  return backendURL;
}

// Функція для отримання повного API базового URL
export function getApiBaseURL() {
  return `${getBackendURL()}/api/v1`;
} 